import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive({ selector: '[customerAppEquityPageData]' })
export class EquityPageDataDirective {
  viewContainerRef = inject(ViewContainerRef);
}
